module.exports = __webpack_public_path__ + "heart.464452b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/retailers/heart.png
// module id = 1748
// module chunks = 0